@if (photos.length > 0) {
    <div class="flex items-center gap-2 mx-4 mb-2">
        @for (photo of photos; track photo.url; let i = $index) {
            <div class="relative">
                <img [src]="photo.url" alt="{{ 'willy.photo.preview-alt' | translate }}"
                    class="size-14 rounded-xl object-cover" />
                <button
                    class="absolute -top-2 -right-2 bg-grey-700 text-white rounded-full size-5 flex items-center justify-center cursor-pointer"
                    (click)="removePhoto(i)" [attr.aria-label]="'willy.photo.remove' | translate">
                    <vw-close-icon class="size-3"></vw-close-icon>
                </button>
            </div>
        }
    </div>
}
@if (photoError) {
    <p class="text-red-600 text-xs mx-4 mb-2">{{ 'willy.photo.error.' + photoError | translate }}</p>
}
<div class="flex bg-gray-100 rounded-full items-center justify-between pr-4 mx-4">
    <input type="text"
        class="bg-transparent outline-none w-full placeholder:text-[#475569] placeholder:text-sm py-4 px-5"
        placeholder="{{ 'common.modals.ai-actions.content.message.placeholder' | translate }}" [(ngModel)]="message"
        (keyup.enter)="onEnter()" (focus)="onInputFocus()" (blur)="onInputBlur()">
    <input #photoInput type="file" accept="image/jpeg,image/png" multiple class="hidden"
        (change)="onPhotoSelected($event)">
    <button class="bg-transparent rounded-full size-9 shrink-0 cursor-pointer flex items-center justify-center text-[#475569]"
        (click)="onPhotoButtonClick()" [attr.aria-label]="'willy.photo.attach' | translate">
        <vw-camera-icon class="size-6"></vw-camera-icon>
    </button>
    <button class="bg-transparent rounded-full size-9 shrink-0 cursor-pointer flex items-center justify-center"
        (click)="onSendButtonClick()">
        <vw-icon-svg iconUrl="/assets/svg/send.svg" width="24px" height="24px"></vw-icon-svg>
    </button>
</div>
